import { handleAPI, API_VERSION_TWO } from 'utils/apiUtils'
import { Action } from 'types/redux'
import * as actions from './actions'
import { PaymentConfigurationType } from './reducer'

type DefaultBankPayload = { bank_account_id: number; payment_mode: 'mudad' | 'offline' }

const isOnboarding = window.location.hash.includes('/onboarding')

const urlPrefix = isOnboarding ? 'onboarding/payroll/' : ''

export function paymentMethodsLoad(): Action {
  const url = `/${API_VERSION_TWO}/${urlPrefix}commercial_registrations/payment_methods`
  return {
    type: actions.PAYMENT_METHODS_LOAD,
    payload: handleAPI(url, {}, 'GET'),
  }
}

export function paymentMethodLoad(id: number): Action {
  const url = `/${API_VERSION_TWO}/${urlPrefix}commercial_registrations/${id}/payment_method_details`
  return {
    type: actions.PAYMENT_METHOD_LOAD,
    payload: handleAPI(url, {}, 'GET'),
  }
}

export function paymentMethodChangeDefaultBank(cr_id: number, data: DefaultBankPayload): Action {
  const url = `/${API_VERSION_TWO}/${urlPrefix}commercial_registrations/${cr_id}/payrun_payment_configurations`

  return {
    type: actions.PAYMENT_METHOD_CHANGE_DEFAULT_BANK,
    payload: handleAPI(url, {}, 'POST', data),
  }
}

// ? to change the current payment 'offline' | 'mudad'
export function paymentMethodSetDefault(data: { cr_id: number; id: number }): Action {
  const url = `/${API_VERSION_TWO}/${urlPrefix}commercial_registrations/${data.cr_id}/payrun_payment_configurations/${data.id}/set_default`
  return {
    type: actions.PAYMENT_METHOD_SET_DEFAULT,
    payload: handleAPI(url, {}, 'POST'),
  }
}

// ? offline endpoints
// ? show the details of the offline payment
export function offlinePaymentDetailsLoad(data: { cr_id: number; id: number }): Action {
  const url = `/${API_VERSION_TWO}/${urlPrefix}commercial_registrations/${data.cr_id}/offline_banks/${data.id}`

  return {
    type: actions.OFFLINE_PAYMENT_METHOD_DETAILS,
    payload: handleAPI(url, {}, 'GET'),
  }
}

export function mudadIntegrationEnabled(): Action {
  const url = `/${API_VERSION_TWO}/${urlPrefix}payrun_configurations/is_mudad_integration_enabled`
  return {
    type: actions.MUDAD_INTEGRATION_ENABLED,
    payload: handleAPI(url, {}, 'GET'),
  }
}

export function offlinePaymentAddEmployees(cr_id: number, data = {}): Action {
  const url = `/${API_VERSION_TWO}/${urlPrefix}commercial_registrations/${cr_id}/offline_bank_authorizations/add_employees`

  return {
    type: actions.OFFLINE_PAYMENT_METHOD_ADD_EMPLOYEES,
    payload: handleAPI(url, {}, 'POST', data),
  }
}

// ? local actions
export function updateSinglePaymentOfList(data: PaymentConfigurationType): Action {
  return {
    type: actions.PAYMENT_METHODS_UPDATE_ITEM_OF_LIST,
    payload: data,
  }
}

export function paymentMethodCreate(
  cr_id: number,
  data: {
    bank_account_id: number
    payment_mode: 'offline' | 'mudad'
  },
): Action {
  const url = `/${API_VERSION_TWO}/${urlPrefix}commercial_registrations/${cr_id}/payrun_payment_configurations`
  return {
    type: actions.PAYMENT_METHOD_CREATE,
    payload: handleAPI(url, {}, 'POST', data),
  }
}
